import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHowToReg300 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M98.85-187.69v-88.93q0-31.84 16.04-55.65 16.03-23.81 42.57-37.27 51-26 107.69-42.07 56.7-16.08 133.7-16.08 30 0 55.8 2.42 25.81 2.42 48.2 7.27l-53.08 53.08q-11-2-23.81-2.39-12.81-.38-27.11-.38-71 0-124.43 15.84Q221-336 185-316q-13.62 7.31-19.88 17.08-6.27 9.77-6.27 22.3v28.93h242.3l60 60H98.85ZM617-157.85 492.85-282 535-324.15l82 82 202-202L861.15-402 617-157.85Zm-317.11-375.5q-41.04-41.03-41.04-98.96 0-57.92 41.04-98.96 41.03-41.04 98.96-41.04 57.92 0 98.96 41.04 41.03 41.04 41.03 98.96 0 57.93-41.03 98.96-41.04 41.04-98.96 41.04-57.93 0-98.96-41.04Zm101.26 285.66Zm54.2-328.12q23.5-23.5 23.5-56.5t-23.5-56.5q-23.5-23.5-56.5-23.5t-56.5 23.5q-23.5 23.5-23.5 56.5t23.5 56.5q23.5 23.5 56.5 23.5t56.5-23.5Zm-56.5-56.5Z" })
});
export default SvgHowToReg300;
